import styled from 'styled-components';

const Component = styled.input`
  background: none;
  width: ${props => (props.paddingLeft ? '80%' : '90%')};
  border: none;
  border-radius: 0;
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumRegular}
  margin-top: 6px;
  padding: 0;
  ${({ paddingLeft }) =>
    paddingLeft &&
    `padding-left: ${paddingLeft};
  `};
  :hover {
    outline: none;
  }
  :focus {
    outline: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textHint};
  }
  ${({ isTextArea }) =>
    isTextArea &&
    `resize: none;
    background-color: unset;
  `}
`;

export default Component;
